module.exports = __webpack_public_path__ + "img/Loading.38344c13.gif";